var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape17 = function SvgShape17(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.21 131.175c-7.975 10.437-11.963 15.655-16.568 18.032a23.22 23.22 0 0 1-21.284 0c-4.605-2.377-8.592-7.595-16.567-18.032l-26.485-34.66c-4.85-6.349-7.276-9.523-8.477-12.921a22.78 22.78 0 0 1 0-15.188c1.201-3.398 3.627-6.572 8.477-12.92l26.485-34.661C44.766 10.388 48.753 5.17 53.358 2.793a23.22 23.22 0 0 1 21.284 0c4.605 2.377 8.593 7.595 16.567 18.032l26.485 34.66c4.851 6.349 7.276 9.523 8.477 12.921a22.8 22.8 0 0 1 0 15.188c-1.201 3.398-3.626 6.572-8.477 12.92z",
    opacity: 0.1
  })));
};
export default SvgShape17;